<template>
    <main
        class="flex items-start p-4 md:p-12 space-x-0 flex-col md:flex-row md:space-x-28"
    >
        <div
            :class="{ 'off-page': hideSidebar }"
            class="z-30 md:z-0 bg-white dark:bg-black-900 transition duration-150 w-full min-h-screen md:min-h-0 absolute left-0 px-4 md:px-0 md:static"
            id="main-sidebar"
        >
            <MainSidebar @toggle-sidebar="toggleSidebar" />
        </div>

        <div class="w-full">
            <MainHeader @toggle-sidebar="toggleSidebar" class="mb-8" />
            <router-view />
        </div>
    </main>
</template>

<script>
import MainSidebar from "./MainSidebar";
import MainHeader from "./MainHeader";

export default {
    name: "MainLayout",
    components: {
        MainSidebar,
        MainHeader,
    },
    data() {
        return {
            hideSidebar: true,
        };
    },
    watch: {
        currentRoute() {
            this.hideSidebar = true;
        },
    },
    computed: {
        currentRoute() {
            return this.$route.name;
        },
    },
    methods: {
        toggleSidebar() {
            this.hideSidebar = !this.hideSidebar;
        },
    },
};
</script>

<style scoped>
#main-sidebar {
    transition: 0.3s;
}

.off-page {
    left: -768px;
}

@media (min-width: 768px) {
    #main-sidebar {
        max-width: 220px;
    }
}
</style>
